<template>
	<v-container fluid>
		<versions-list />
	</v-container>
</template>

<script>
import VersionsList from './VersionsList'
export default {
  name: 'SettingsVersionsIndex',
  components: {
  	VersionsList
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>